import {Entity} from '@s-ui/domain'

export class LoanCalculationsB2CTransactionsEntity extends Entity {
  /**
   * @constructor
   * @param {Array} availableTerms
   * @param {String} id
   * @param {String} fareInsuranceId
   * @param {String} insuranceId
   * @param {Number} capital
   * @param {String} dateFirstInstallment
   * @param {String} dateSignUp
   * @param {Number} fee
   * @param {Number} firstFee
   * @param {String} insuranceName
   * @param {Object} insuranceCoverages
   * @param {String} lender
   * @param {String} lenderLegalTextId
   * @param {Number} lifeInsuranceAmount
   * @param {Number} insuranceRate
   * @param {Number} maxEntry
   * @param {Number} minEntry
   * @param {Number} openingExpenses
   * @param {Boolean} isOpeningExpensesFinanced
   * @param {Number} openingPercentage
   * @param {Number} tae
   * @param {Number} terms
   * @param {Number} tin
   * @param {Number} totalAmountDue
   * @param {Number} totalInterest
   * @param {Number} totalLoanAmount
   * @param {Number} totalLoanCost
   * @param {Number} totalPriceTerms
   * @param {Number} totalTermsAmount
   * @param {Number} totalInsuranceAmount
   * @param {Number} computedPrice
   * @param {String} selectedOption
   * @param {Number} maxEntryToGetDiscount
   * @param {String} dateOfferEnd
   */
}
